import { api } from './configs/axiosConfig';

const endPoint = "/rooms";

export const roomAPI = {
    searchRooms: async function (key) {
        const reponse = await api.request({
            url: `${endPoint}/search-rooms`,
            method: 'GET',
            params: { key }
        });

        return reponse.data;
    },
    getRoomOccupy: async function (roomNo) {
        const reponse = await api.request({
            url: `${endPoint}/room-occupy`,
            method: 'GET',
            params: { roomNo }
        });

        return reponse.data;
    }
}